export const ACCEPTED_RESERVATION_OPERATIONS = [
  'free_preview',
  'manuscript_generation',
  'rewrite',
] as const;

export type AcceptedReservationOperation = (typeof ACCEPTED_RESERVATION_OPERATIONS)[number];

export function normalizeReservationOperation(
  operation: string,
): AcceptedReservationOperation | null {
  if (operation === 'generate') {
    return 'manuscript_generation';
  }
  if ((ACCEPTED_RESERVATION_OPERATIONS as readonly string[]).includes(operation)) {
    return operation as AcceptedReservationOperation;
  }
  return null;
}

export function isAcceptedReservationOperation(operation: string): boolean {
  return normalizeReservationOperation(operation) !== null;
}
